module.exports = __webpack_public_path__ + "img/y_2010_hover.11392e8d.png";